export const filterAgentsByType = (agents) => {
  return {
    servicingAgents: agents.filter(
      (agent) => agent.agentType === "Servicing Agent"
    ),
    writingAgents: agents.filter(
      (agent) =>
        agent.agentType === "Writing Agent" ||
        agent.agentType === "Partner Agent"
    ),
  };
};
